module.exports = __webpack_public_path__ + "static/img/img13.3ef5f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img13.png
// module id = Gg1z
// module chunks = 0